"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgScriptRun(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm12.81708 2.56c.20227-2.09662.73669-1.95062.73669-1.95062a6.96646 6.96646 0 0 1 .44623 1.95062zm-3.92808 4.44a1.97058 1.97058 0 0 1 .89819.21613l1.42389.7323c.35718-2.61506.80957-6.02753.80957-6.02753s.11857-1.8809 1.10673-1.9209h-8.69488s-1.0275.04-1.26471 1.60077c-.13855.91223-.601 4.31128-.96149 6.97961h4.817a1.85552 1.85552 0 0 1 1.8657-1.58038zm-1.889 2.43872h-7s.3667 2.56128 1.30359 2.56128h5.69641zm2.32984-1.33328 6.22221 3.2a.85.85 0 0 1 .33064.29759.75847.75847 0 0 1 -.33064 1.09153l-6.22221 3.2a.96625.96625 0 0 1 -.44113.10544.84786.84786 0 0 1 -.88871-.8v-6.4a.848.848 0 0 1 .88887-.8.965.965 0 0 1 .44097.10544z' })));
}
exports.default = SvgScriptRun;
